export default __webpack_public_path__ + "static/media/IMG_2195.5663c086.JPG";